
<v-tooltip
  top
  right
  color="primary"
  :disabled="disabled || (!text && !$slots.tooltip)"
>
  <template v-slot:activator="{ on, attrs }">
    <div
      :class="contentClass"
      class="w-fit"
      v-bind="attrs"
      v-on="on"
      @mouseenter="getHTMLText"
    >
      <slot></slot>
    </div>
  </template>
  <span v-if="text" v-html="text"></span>
  <fragment v-else>
    <div
      v-if="isPlainTextSlot"
      style="max-width: 500px; text-wrap: wrap"
      class="break-all line-clamp-20"
      v-html="htmlText"
    ></div>
    <div
      v-else
      class="break-all line-clamp-20"
      style="max-width: 500px; text-wrap: wrap"
    >
      <slot name="tooltip"></slot>
    </div>
  </fragment>
</v-tooltip>
